import { useState } from 'react';

import './Schedule.css';
import '../index.css'

import ImageCard from '../components/ImageCard';
import Spacer from '../components/Spacer.js'

function Schedule() {
    const [loading, setLoading] = useState(true);

    let parking = (
        <div>
            <p className='card-text'>För dig som tar dig hit med bil så finns parkering längst in förbi gästparkeringen, markerat i vitt på bilden ovan.</p>
        </div>
    )

    return (
        <div className='home-main'>
            <p className='home-main-text'>Vigsel</p>
            <Spacer />
            <div className='image-maps-card'>
                <img className='card-item1' src="/vigsel.png" alt="vigsel" />
                {loading && (<div className='iframe-loader item2'>Laddar Karta...</div>)}
                <iframe
                    className='card-item2'
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2242.4399393166746!2d13.203310977089568!3d55.80296238812637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4653bfee508b25a5%3A0xb9ae2d628c5ed577!2sLilleg%C3%A5rd!5e0!3m2!1ssv!2sse!4v1771185565542!5m2!1ssv!2sse"
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Google Maps"
                    onLoad={() => setLoading(false)}
                ></iframe>
                <div className='separator'></div>
                <div className='card card-item3'>
                    <p className='card-text'>16.00 - Vigsel i Kävlinge</p>
                    <p className='card-small-text'>Klockan fyra börjar vår vigsel på Lillegårds vigselplats. Efter det blir det mingel, middag, och fest!</p>
                    <p className='card-small-text'>Adress: Fredriksrovägen 85, 244 91 Kävlinge</p>
                </div>
            </div>
            <Spacer />
            <div className='image-cards-container'>
                <ImageCard
                    title="Parkering"
                    text={parking}
                    imagePath="/parking.png"
                    imageAlt="parking"
                />
            </div>
            <Spacer />
        </div >
    );
}

export default Schedule;